<template>
  <el-scrollbar :native="false" style="height: 100%;width: 100%;">
    <el-main>
      <div class="screen-form">
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="inputSearch"
                  style="width: 300px; margin-right: 10px"></el-input>

        <span>状态：</span>
        <el-select v-model="valueStatus" placeholder="请选择" @change="requestCollectionTaskList">
          <el-option
              v-for="item in optionStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" style="vertical-align: middle;margin-left: 5px;" @click="requestCollectionTaskList">
          搜索
        </el-button>
      </div>
      <div class="switch">
        <el-button type="primary" plain icon="el-icon-video-play" @click="startTask(true)">启动</el-button>
        <el-button type="info" plain icon="el-icon-video-pause" @click="startTask(false)">停止</el-button>
      </div>
      <el-table ref="multipleTable" :data="collectionTaskList" tooltip-effect="dark" style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="websiteName" label="采集器名称" width="200">
        </el-table-column>
        <el-table-column prop="runningStatus" label="状态" width="120">
          <template slot-scope="scope">
            {{ scope.row.runningStatus ? '启动' : '暂停' }}
          </template>
        </el-table-column>
        <el-table-column prop="isTimer" label="是否定时启动" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.isTimer ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="completNum" label="完成任务数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mistakeNum" label="错误任务数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remarks" label="消息" show-overflow-tooltip></el-table-column>
        <el-table-column prop="startTime" label="定时启动执行时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="stopTime" label="最后执行结束时间" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20, 25, 30]"
            :page-size="listPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listPageTotal">
        </el-pagination>
      </div>
    </el-main>
  </el-scrollbar>
</template>

<script>
export default {
  name: "backCollectionTask",
  data() {
    let tableData = [
      {
        name: '湖南省政府采购网',
        status: '停止',
        isRegularlyStart: '是',
        numDoneTask: '123',
        numErrorTask: '999',
        characterSet: '采购',
        numRestTask: '123',
        message: '消息消息消息',
        startTime: '12:00',
        endTime: '12:00',
        createdTime: '12:00',
        updateTime: '12:00'
      }
    ];

    return {
      inputSearch: '',
      tableData,
      multipleSelection: [],
      optionStatus: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 0,
          label: '停止'
        }, {
          value: 1,
          label: '运行中'
        }
      ],
      valueStatus: null,
      valueEnclosure: '',
      listPageSize: 10,//单页数据数
      listPageTotal: 0,//总数据数量
      listSize: 10,//总页数
      currentPage: 1,//当前页
      collectionTaskList: []
    }
  },
  mounted() {

    this.requestCollectionTaskList()
  },
  methods: {
    toggleSelection(rows) {
      console.log(rows)
      if (rows) {
        rows.forEach(row => {
          console.log(this.$refs.multipleTable.toggleRowSelection)
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.listPageSize = val;
      this.requestCollectionTaskList().then(() => {
        loading.close()
      })
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.currentPage = val;
      this.requestCollectionTaskList().then(() => {
        loading.close()
      })
    },
    startTask(startSwitch = false) {
      if (this.multipleSelection.length > 0) {
        this.$confirm(`是否${startSwitch ? '开始' : '停止'}选中的任务?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          let loading = this.$loading(this.utils.defaultLoadingOptions);
          let data = [];
          this.multipleSelection.forEach(item => {
            data.push(item.programName)
          })
          this.$request.startCollectionTaskList({
            programName: data,
            status: startSwitch ? 'start' : 'stop'
          }).then(res => {
            loading.close();
            if (res.status == 200) {
              let successNum = res.data.success.length;
              let mistakeNum = res.data.mistake.length;
              this.$message({
                type: 'success',
                dangerouslyUseHTMLString: true,
                message: `<span>操作完成，${successNum}条操作成功，<span style="color: red">${mistakeNum}条操作失败!</span></span>`
              });
              this.requestCollectionTaskList();
            } else {
              this.$message({
                type: 'info',
                message: '操作失败！'
              });
              this.requestError(res.status, res.message)
            }
          }, err => {
            console.log(err);
            loading.close();
            this.requestFail(err);
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      } else {
        this.$confirm('请至少选中一条数据！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false
        })
      }
    },
    requestCollectionTaskList() {
      let loading = this.$loading(this.utils.defaultLoadingOptions);

      return new Promise((resolve, reject) => {
        this.$request.collectionTaskList({
          websitName: this.inputSearch || null,
          runningStatus: this.valueStatus || this.valueStatus === 0 ? this.valueStatus : null,
          page: this.currentPage,
          size: this.listPageSize
        }).then(res => {
          loading.close();
          console.log(res);
          if (res.status == 200) {
            resolve(res);

            this.collectionTaskList = res.data.list;
            this.listPageTotal = res.data.total;
          } else {
            this.requestError(res.status, res.message)
          }

        }, err => {
          console.log(err);
          reject(err)
          loading.close();
          this.requestFail(err);
        })
      })
    }
  }
}
</script>

<style scoped>
.screen-form {
  margin-top: 50px;
  margin-bottom: 50px;
}

.pagination-wrap {
  margin-top: 50px;
}

.switch {
  padding-left: 20px;
}
</style>